// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, SET_SUB_RENEW_DATA } from './actions';
import { initialLoginContextProps } from 'types';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState: initialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

export interface AccountReducerActionProps {
    type: string;
    payload?: initialLoginContextProps;
}

const accountReducer = (state: typeof initialState | undefined, action: AccountReducerActionProps) => {
    if (state === undefined) {
        state = initialState;
    }

    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user } = action.payload!;
            return {
                ...state,
                isLoggedIn,
                isInitialized: true,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload!;
            return {
                ...state,
                isLoggedIn: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                user: null
            };
        }
        case SET_SUB_RENEW_DATA: {
            if (action.payload) {
                const { required_subscription, _ptxn } = action.payload;
                return { ...state, required_subscription, _ptxn };
            }

            return { ...state };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
